/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Paper, Typography, Collapse, Tabs, Tab, InputAdornment, CircularProgress, Badge, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core'

import GroupIcon from '../components/Groups/GroupIcon'
import GroupTable from '../components/Groups/GroupTable'
import GroupDetail from '../components/Groups/GroupDetail'

import FieldIcon from '../components/Fields/FieldIcon'
import FieldTable from '../components/Fields/FieldTable'
import FieldDetail from '../components/Fields/FieldDetail'

import GlobalFieldList from '../components/UtilComps/GlobalFieldList';
import GlobalFieldIcon from '../components/UtilComps/GlobalFieldIcon';
import Filter from '../components/UtilComps/Filter'

import RecordIcon from '../components/Records/RecordIcon';
import RecordList from '../components/Records/RecordList';

import Record from '../components/Records/Record';

const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);
  
const AntTab = withStyles((theme) => ({
    root: {
      textTransform: 'none',
      minWidth: 72,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
      },
      '&:focus': {
        color: '#40a9ff',
      },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    badge: {
        padding: `0 ${theme.spacing.unit * 0}px`,
    },
    headerStyle : {
        color : '#707070',
        backgroundColor : '#F5F5F5',
        fontSize : 11,
        border : 'none'
    }
})

class RecoSpace extends Component {
    state = {
        level_1_tab_index : null,
        level_2_tab_index : null,
        group_in_focus : null,
        field_in_focus : null,
        field_type_in_focus : null,
        show_group_detail : false,
        show_field_detail : false,
        similarity_type : "combined_similarity",
        record_in_focus : null,
        singleton_in_focus : null
    }

    componentDidUpdate (prevProps) {
        var equal = require('fast-deep-equal');

        let previous_group = prevProps.group_in_focus
        let current_group = this.props.group_in_focus

        let previous_similar_group_in_focus = prevProps.similar_group_in_focus
        let current_similar_group_in_focus = this.props.similar_group_in_focus

        let previous_field = prevProps.field_in_focus
        let current_field = this.props.field_in_focus

        let previous_global_field = prevProps.global_field_in_focus
        let current_global_field = this.props.global_field_in_focus

        let previous_search = prevProps.search_results
        let current_search = this.props.search_results

        if (previous_group === null && current_group !== null) {
            this.setState({
                ...this.state,
                level_1_tab_index : 0,
                level_2_tab_index : 0,
                show_group_detail : this.state.show_group_detail ? false : this.state.show_group_detail,
                show_field_detail : this.state.show_field_detail ? false : this.state.show_field_detail
            })

            return
        }

        if (previous_group !== null && current_group === null) {
            this.setState({
                ...this.state,
                level_1_tab_index : current_search !== null ? 2 : null,
                level_2_tab_index : current_search !== null ? 0 : null,
                show_group_detail : false,
                show_field_detail : false
            }, () => this.props.update_space_state(1, null))

            return
        }

        if (previous_similar_group_in_focus !== null && current_similar_group_in_focus === null) {
            this.setState({
                ...this.state,
                // level_1_tab_index : 0,
                // level_2_tab_index : 0,
                show_group_detail : false,
                show_field_detail : false
            }, () => this.props.update_space_state(1, null))

            return
        }

        if (previous_field === null && current_field !== null) {
            this.setState({
                ...this.state,
                level_1_tab_index : 1,
                level_2_tab_index : 0,
                show_group_detail : false,
                show_field_detail : false
            }, () => this.props.update_space_state(1, null))

            return
        }

        if (previous_field !== null && current_field === null) {
            this.setState({
                ...this.state,
                level_1_tab_index : 0,
                level_2_tab_index : 0
            })

            return
        }

        if (previous_search === null && current_search !== null)  {
            this.setState({
                ...this.state,
                level_1_tab_index : 2,
                level_2_tab_index : 0,
                show_group_detail : false,
                show_field_detail : false
            }, () => this.props.update_space_state(1, null))

            return
        }

        if (previous_search !== null && current_search === null)  {
            this.setState({
                ...this.state,
                level_1_tab_index : 0,
                level_2_tab_index : 0
            })

            return
        }

        if (!equal(previous_search, current_search)) {
            this.setState({
                ...this.state,
                level_1_tab_index : 2
            })

            return
        }

        let prev_group_list = prevProps.similar_to_group_in_focus
        let current_group_list = this.props.similar_to_group_in_focus

        if (!equal(prev_group_list, current_group_list)) {
            if (this.state.group_in_focus !== null) {
                // let group_in_focus = current_group_list.groups.find(group => group.group_id === this.state.group_in_focus.group_id)
                // this.focusGroup(group_in_focus)
                this.setState({...this.state, show_group_detail : false, show_field_detail : false})
            }
        }

        if (previous_global_field === null && current_global_field !== null) {
            if (current_group === null) {
                this.setState({
                    ...this.state,
                    level_1_tab_index : 0,
                    level_2_tab_index : 0,
                    show_group_detail : this.state.show_group_detail ? false : this.state.show_group_detail,
                    show_field_detail : this.state.show_field_detail ? false : this.state.show_field_detail
                })
    
                return
            } 
        }

        if (previous_global_field !== null && current_global_field === null) {
            if (current_group === null) {
                this.setState({
                    ...this.state,
                    level_1_tab_index : 0,
                    level_2_tab_index : 0,
                    show_group_detail : false,
                    show_field_detail : false
                }, () => this.props.update_space_state(1, null))
    
                return
            } 
        }
    }

    getBodyHeight = () => {
        let bodyHeight = this.props.space_height - 100
        return bodyHeight
    }

    renderLevel0 = () => {
        return (
            <Fragment>
                <Paper
                    square 
                    variant = 'outlined' 
                    style = {{
                        width : '100%',
                        height  : '50px',
                        display : 'flex',
                        flexDirection : 'row',
                        alignItems : 'center',
                        padding : '10px'
                    }}
                >
                    <Typography style = {{margin : 0, padding : 0}} variant = 'subtitle2' color = 'textPrimary'>Similar Entities by</Typography>
                    <FormControl
                        hiddenLabel
                        size = 'small'
                        margin = "dense"
                        style = {{
                            flexGrow : 1,
                            marginLeft : '15px'
                        }}>
                        {/* <InputLabel>Similarity Type</InputLabel> */}
                        <Select
                            value = {this.state.similarity_type}
                            onChange = {(event) => this.setState({...this.state, similarity_type : event.target.value})}
                        >
                            <MenuItem value = 'name_similarity'>Name Similarity</MenuItem>
                            <MenuItem value = 'value_similarity'>Value Similarity</MenuItem>
                            <MenuItem value = 'combined_similarity'>Combined Similarity</MenuItem>
                        </Select>
                    </FormControl>
                </Paper>    
            </Fragment>
        )
    }

    renderLevel1 = () => {
        return (
            <Fragment>
                <Paper
                    square 
                    variant = 'outlined' 
                    style = {{
                        width : '100%', 
                        height : '50px',
                        display : 'flex',
                        flexDirection : 'row'
                    }}
                >
                    <Tabs
                        variant = "scrollable"
                        value={this.state.level_1_tab_index}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={(event, newValue) => this.setState({
                            ...this.state, 
                            level_1_tab_index : newValue, 
                            level_2_tab_index : 0,
                            show_group_detail : false,
                            show_field_detail : false
                        },() => this.props.update_space_state(1, null))}
                    >
                        <Tab
                            disabled = {this.props.group_in_focus === null}
                            style = {{textTransform : 'none'}}
                            label = {
                                <div 
                                    style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'column', alignItems : 'flex-start'}}
                                >
                                    <Typography variant = 'caption'>Similar to</Typography>
                                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                        <GroupIcon group_display_name = {this.props.group_display_name}/>
                                        <Typography 
                                            style = {{paddingLeft : '5px', fontSize : 13}} 
                                            noWrap 
                                            display = 'inline-block' 
                                            variant = 'body2' 
                                            color = {this.state.level_1_tab_index === 0 ? "primary" : "textSecondary"}
                                        >
                                            {this.props.group_in_focus === null ? "..." : this.props.group_in_focus.group_name}
                                        </Typography>
                                    </div>
                                </div>
                            }
                        />
                        <Tab
                            disabled = {this.props.field_in_focus === null}
                            style = {{textTransform : 'none'}}
                            label = {
                                <div 
                                    style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'column', alignItems : 'flex-start'}}
                                >
                                    <Typography variant = 'caption'>Similar to</Typography>
                                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                        <RecordIcon field_display_name = {this.props.field_display_name}/>
                                        <Typography 
                                            style = {{paddingLeft : '5px', fontSize : 13}} 
                                            noWrap 
                                            display = 'inline-block' 
                                            variant = 'body2' 
                                            color = {this.state.level_1_tab_index === 1 ? "primary" : "textSecondary"}
                                        >
                                            {this.props.field_in_focus === null ? "..." : this.props.field_in_focus.record_id}
                                        </Typography>
                                    </div>
                                </div>
                            }
                        />
                        {/* <Tab
                            disabled = {this.props.global_field_in_focus === null}
                            style = {{textTransform : 'none'}}
                            label = {
                                <div 
                                    style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'column', alignItems : 'flex-start'}}
                                >
                                    <Typography variant = 'caption'>Similar to</Typography>
                                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                        <GlobalFieldIcon
                                            global_field_display_name = {this.props.global_field_display_name}
                                        />
                                        <Typography 
                                            style = {{paddingLeft : '5px', fontSize : 13}} 
                                            noWrap 
                                            display = 'inline-block' 
                                            variant = 'body2' 
                                            color = {this.state.level_1_tab_index === 2 ? "primary" : "textSecondary"}
                                        >
                                            {this.props.global_field_in_focus === null ? "..." : this.props.global_field_in_focus}
                                        </Typography>
                                    </div>
                                </div>
                            }
                        /> */}
                        <Tab
                            style = {{textTransform : 'none'}}
                            disabled = {this.props.search_results === null}
                            label = {
                                <div 
                                    style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'column', alignItems : 'flex-start'}}
                                >
                                    <Typography variant = 'caption'>Search</Typography>
                                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                        <Typography style = {{marginleft : '5px', fontSize : 13}} noWrap display = 'inline-block' variant = 'body2'>Results</Typography>
                                    </div>
                                </div>
                            }
                        />
                    </Tabs>
                </Paper>
            </Fragment>
        )
    }

    renderLevel2 = () => {
        switch(this.state.level_1_tab_index){
            case 0:
                return this.renderChildTabs("similar_to_group_in_focus", "Select a group to see similar entities")
            
            case 1:
                return this.renderChildTabs("similar_to_field_in_focus", "Select a field to see similar entities")
            
            // case 2:
            //     return this.renderChildTabs("similar_to_global_field_in_focus", "Select a global field to see similar entities")
            
            case 2:
                    return this.renderChildTabs("search_results", "Search to see the results here.")
            default:
                return null
        }
    }

    renderChildTabs = () => {
        return (
            <Fragment>
                <Paper
                    square
                    variant = 'outlined'
                >
                    <AntTabs
                        onChange = {(event, newValue) => this.setState({...this.state, level_2_tab_index: newValue, record_in_focus : null, singleton_in_focus : null, field_in_focus : null})}
                        indicatorColor="primary"
                        textColor="primary"
                        value = {this.state.level_2_tab_index}
                        variant = 'scrollable'
                        scrollButtons="auto"
                    >
                        <AntTab
                            label = {this.props.group_display_name + "s"}
                        />
                        <AntTab
                            label = {this.props.field_display_name + "s"}
                        />
                        <AntTab
                            label = "Singletons"
                        />
                        {/* <AntTab
                            label = {this.props.global_field_display_name + " Records"}
                        /> */}
                    </AntTabs>
                </Paper>
            </Fragment>
        )
    }

    renderChildTabContent = () => {
        console.log("child tab content")
        if (this.state.level_1_tab_index === 0) {
            switch (this.state.level_2_tab_index) {
                case 0 :
                    return this.renderSimilarGroupTable("similar_to_group_in_focus", "groups", ["$pin","$icon", "Name", "Records", "Score", "$options"], true)
                
                case 1 :
                    return this.renderSimilarFieldTable("similar_to_group_in_focus", "fields", ["$icon", "Name", "Score", "$options"], true) 
                
                case 2 :
                    return this.renderSimilarSingletonTable("similar_to_group_in_focus", "singletons", ["$icon", "Name", "Score", "$options"], true)
                
                default : 
                    return null
            }
        } 
        else if (this.state.level_1_tab_index === 1) {
            switch (this.state.level_2_tab_index) {
                case 0 :
                    return this.renderSimilarGroupTable("similar_to_field_in_focus", "groups", ["$pin","$icon", "Name", "Records", "Score", "$options"], true)
                
                case 1 :
                    return this.renderSimilarFieldTable("similar_to_field_in_focus", "fields", ["$icon", "Name", "Score", "$options"], true) 
                
                case 2 :
                    return this.renderSimilarSingletonTable("similar_to_field_in_focus", "singletons", ["$icon", "Name", "Score", "$options"], true)
                
                default : 
                    return null
            }

        } 
        // else if (this.state.level_1_tab_index === 2) {
        //     switch (this.state.level_2_tab_index) {
        //         case 0 :
        //             return this.renderSimilarGroupTable("similar_to_global_field_in_focus", "groups", ["$pin","$icon", "Name", "Fields", "Score", "$options"], true)
                
        //         case 1 :
        //             return this.renderSimilarFieldTable("similar_to_global_field_in_focus", "fields", ["$icon", "Name", "Score", "$options"], true) 
                
        //         // case 2 :
        //         //     return this.renderSimilarSingletonTable("similar_to_global_field_in_focus", "singletons", ["$icon", "Name", "Score", "$options"], true)
        //         default : 
        //             return null
        //     }
        // } 
        else if (this.state.level_1_tab_index === 2) {
            switch (this.state.level_2_tab_index) {
                case 0 :
                    return this.renderSimilarGroupTable("search_results", "groups", ["$pin","$icon", "Name", "Records", "Score", "$options"], false)
                
                case 1 :
                    return this.renderSimilarFieldTable("search_results", "grouped_fields", ["$icon", "Name", "Score", "$options"], false) 
                
                case 2 :
                    return this.renderSimilarSingletonTable("search_results", "singletons", ["$icon", "Name", "$options"], false)
                    
                default : 
                    return null
            }
        }
    }

    getRecoLabel = () => {
        if (this.state.level_1_tab_index === 0) {
            switch (this.state.level_2_tab_index) {
                case 0:
                    return (
                        <div 
                            style = {{
                                padding : '10px',
                                width : '100%',
                                display : 'flex',
                                flexDirection : 'row',
                                alignItems : 'center'
                            }}
                        >
                            <Typography style = {{marginRight : '5px'}} variant = 'caption' color = 'textSecondary'>{this.props.group_display_name + " similar to "}</Typography>
                            <GroupIcon group_display_name = {this.props.group_display_name}/>
                            <Typography style = {{marginLeft : '5px', fonSize : 12}} variant = 'body2'>{this.props.group_in_focus.group_name}</Typography>
                        </div>
                    )
                
                case 1:
                    return (
                        <div 
                            style = {{
                                padding : '10px',
                                width : '100%',
                                display : 'flex',
                                flexDirection : 'row',
                                alignItems : 'center'
                            }}
                        >
                            <Typography style = {{marginRight : '5px'}} variant = 'caption' color = 'textSecondary'>{this.props.field_display_name + " similar to "}</Typography>
                            <GroupIcon group_display_name = {this.props.group_display_name}/>
                            <Typography style = {{marginLeft : '5px', fonSize : 12}} variant = 'body2'>{this.props.group_in_focus.group_name}</Typography>
                        </div>
                    )
                
                case 2: 
                    return (
                        <div 
                            style = {{
                                padding : '10px',
                                width : '100%',
                                display : 'flex',
                                flexDirection : 'row',
                                alignItems : 'center'
                            }}
                        >
                            <Typography style = {{marginRight : '5px'}} variant = 'caption' color = 'textSecondary'>Singletons similar to </Typography>
                            <GroupIcon group_display_name = {this.props.group_display_name}/>
                            <Typography style = {{marginLeft : '5px', fonSize : 12}} variant = 'body2'>{this.props.group_in_focus.group_name}</Typography>
                        </div>
                    )

                case 3: 
                    return (
                        <div 
                            style = {{
                                padding : '10px',
                                width : '100%',
                                display : 'flex',
                                flexDirection : 'row',
                                alignItems : 'center'
                            }}
                        >
                            <Typography style = {{marginRight : '5px'}} variant = 'caption' color = 'textSecondary'>{this.props.global_field_display_name + " similar to "}</Typography>
                            <GroupIcon group_display_name = {this.props.group_display_name}/>
                            <Typography style = {{marginLeft : '5px', fonSize : 12}} variant = 'body2'>{this.props.group_in_focus.group_name}</Typography>
                        </div>
                    )
                default : 
                    return null
            }
        } 
        
        if (this.state.level_1_tab_index === 1 && this.props.field_in_focus) {
            switch (this.state.level_2_tab_index) {
                case 0:
                    return (
                        <div 
                            style = {{
                                padding : '10px',
                                width : '100%',
                                display : 'flex',
                                flexDirection : 'row',
                                alignItems : 'center'
                            }}
                        >
                            <Typography style = {{marginRight : '5px'}} variant = 'caption' color = 'textSecondary'>{this.props.group_display_name + " similar to "}</Typography>
                            <RecordIcon field_display_name = {this.props.field_display_name}/>
                            <Typography style = {{marginLeft : '5px', fonSize : 12}} variant = 'body2'>{this.props.field_in_focus.field}</Typography>
                        </div>
                    )
                
                case 1:
                    return (
                        <div 
                            style = {{
                                padding : '10px',
                                width : '100%',
                                display : 'flex',
                                flexDirection : 'row',
                                alignItems : 'center'
                            }}
                        >
                            <Typography style = {{marginRight : '5px'}} variant = 'caption' color = 'textSecondary'>{this.props.field_display_name + " similar to "}</Typography>
                            <RecordIcon field_display_name = {this.props.field_display_name}/>
                            <Typography style = {{marginLeft : '5px', fonSize : 12}} variant = 'body2'>{this.props.field_in_focus.field}</Typography>
                        </div>
                    )
                
                case 2: 
                    return (
                        <div 
                            style = {{
                                padding : '10px',
                                width : '100%',
                                display : 'flex',
                                flexDirection : 'row',
                                alignItems : 'center'
                            }}
                        >
                            <Typography style = {{marginRight : '5px'}} variant = 'caption' color = 'textSecondary'>Singletons similar to </Typography>
                            <RecordIcon field_display_name = {this.props.field_display_name}/>
                            <Typography style = {{marginLeft : '5px', fonSize : 12}} variant = 'body2'>{this.props.field_in_focus.field}</Typography>
                        </div>
                    )

                case 3: 
                    return (
                        <div 
                            style = {{
                                padding : '10px',
                                width : '100%',
                                display : 'flex',
                                flexDirection : 'row',
                                alignItems : 'center'
                            }}
                        >
                            <Typography style = {{marginRight : '5px'}} variant = 'caption' color = 'textSecondary'>{this.props.global_field_display_name + " similar to "}</Typography>
                            <RecordIcon field_display_name = {this.props.field_display_name}/>
                            <Typography style = {{marginLeft : '5px', fonSize : 12}} variant = 'body2'>{this.props.field_in_focus.field}</Typography>
                        </div>
                    )
                default : 
                    return null
            }
        }  
    }

    renderSimilarGroupTable = (entity_key, value_key, columns, filter_similarity) => {
        console.log("similar group:", this.props[entity_key])
        if (this.props[entity_key] !== null) {
            let group_data = this.props[entity_key][value_key]

            console.log("IFC :: Similar Group Data", group_data)
            if (group_data.length === 0) {
                return (
                    <div>
                        {entity_key === 'search_results' && <div style = {{width : '100%', height : '50px', display : "flex", flexDirection : 'row'}}>
                            <div>
                                <Filter 
                                    key = {'group'} 
                                    group_filter = {this.props.search_range_filter.group}
                                    update_filter = {(filter,key) => this.props.update_search_range_filter(filter,key)}
                                />
                            </div>
                            <Typography style = {{width : '10%', marginTop : '5px'}} variant = 'subtitle2' color = 'textPrimary'> of {this.props.search_range_filter.group.total_count}</Typography>
                        </div>}
                        <div
                            style = {{
                                width : '100%',
                                height : (this.getBodyHeight() - 100) + "px",
                                display : 'flex',
                                flexDirection : 'row',
                                justifyContent : 'center',
                                alignItems : 'center'
                            }}
                        >
                            <Typography variant = 'caption' color = 'textSecondary'>No similar groups available</Typography>
                        </div>
                    </div>    
                )
            } else {
                return (
                    <div>
                        {entity_key === 'search_results' && <div style = {{width : '100%', height : '50px', display : "flex", flexDirection : 'row'}}>
                            <div>
                                <Filter 
                                    key = {'group'} 
                                    group_filter = {this.props.search_range_filter.group}
                                    update_filter = {(filter,key) => this.props.update_search_range_filter(filter,key)}
                                />
                            </div>
                            <Typography style = {{width : '10%', marginTop : '5px'}} variant = 'subtitle2' color = 'textPrimary'> of {this.props.search_range_filter.group.total_count}</Typography>
                        </div>}
                        <div style = {{width : '100%', padding : '10px'}}>
                            {this.getRecoLabel()}
                            <GroupTable 
                                ic_name = {this.props.ic_name}
                                version = {this.props.version}
                                step_tag = {this.props.step_tag}
                                body_height = {this.getBodyHeight() - 100} 
                                group_display_name = {this.props.group_display_name}
                                field_display_name = {this.props.field_display_name}
                                top_margin = "0px" 
                                score_field = "group_score"
                                columns = {columns}
                                groups = {group_data}
                                group_filter = {this.props.similar_to_group_filter}
                                search_label = {"Search Similar " + this.props.group_display_name + "s"}
                                show_search = {false}
                                pinned_groups = {this.props.pinned_groups}
                                pin_group = {(group_id, action) => this.props.pin_group(group_id, action)}
                                focus_group = {(group_object) => this.focusGroup(group_object)}
                                move_field = {(field_data, field_type, drop_result) => this.props.move_field(field_data, field_type, drop_result)}
                                syncing_field = {this.props.syncing_field}
                                delete_group = {(group_data) => this.props.delete_group(group_data)}
                                highlight_name = {true}
                                global_fields = {this.props.global_fields}
                                report_info = {this.props.report_info}
                                update_filter = {(group_filter) => this.props.update_filter(group_filter)}
                            />
                        </div>
                    </div>
                    
                )
            }
        }
    }

    focusGroup = (group_object) => {
        console.log("IFC :: Similar Group Data Focus.", group_object)
        let group
        let space_state
        let show_group_detail
        if (group_object === null) {
            group = null
            space_state = null
            show_group_detail = false
        } else {
            group = group_object
            space_state = 'group_detail'
            show_group_detail = true
        }
        this.setState({...this.state, show_group_detail : show_group_detail}, () => {
            this.props.focus_similar_group(group, () => this.props.update_space_state(1, space_state))
        })

        // console.log("IFC :: Focussed Group : ", group)
        // this.setState({...this.state, group_in_focus : group}, () => {
        //     console.log("Focussing Group in Reco : ", this.state.group_in_focus)
        //     if (group_object !== null) {
        //         this.props.update_space_state(1, 'group_detail')
        //     } else {
        //         this.props.update_space_state(1, null)
        //     }
        // })
    }

    renderSimilarFieldTable = (entity_key, value_key, columns, filter_similarity) => {
        console.log("similar field table:", this.props[entity_key])
        if (this.props[entity_key] !== null) {
            let field_data = this.props[entity_key][value_key]
            console.log('IRC :: Similar Records Data :', field_data)
            if (field_data.length === 0) {
                return (
                    <div>
                        {entity_key === 'search_results' && <div style = {{width : '100%', height : '50px', display : "flex", flexDirection : 'row'}}>
                            <div>
                                <Filter 
                                    key = {'record'} 
                                    group_filter = {this.props.search_range_filter.record}
                                    update_filter = {(filter,key) => this.props.update_search_range_filter(filter,key)}
                                />
                            </div>
                            <Typography style = {{width : '10%', marginTop : '5px'}} variant = 'subtitle2' color = 'textPrimary'> of {this.props.search_range_filter.record.total_count}</Typography>
                        </div>}
                        <div
                            style = {{
                                width : '100%',
                                height : (this.getBodyHeight() - 100) + "px",
                                display : 'flex',
                                flexDirection : 'row',
                                justifyContent : 'center',
                                alignItems : 'center'
                            }}
                        >
                            <Typography variant = 'caption' color = 'textSecondary'>No similar records available</Typography>
                        </div>
                    </div>     
                )
            } else if (this.state.record_in_focus !== null) {
                return (
                    <Record 
                        record={this.state.record_in_focus} 
                        unfocus_record = {() => this.setState({...this.state, record_in_focus : null})}
                        unfocus_field = {()=>this.props.unfocus_field}
                    ></Record>
                )
            } else {
                columns = ["$icon","$options","$golden"]
                Object.keys(field_data[0].wv_field_list).map((field) => columns.push(field))
                columns.push("Score")
                return (
                    <div>
                        {entity_key === 'search_results' && <div style = {{width : '100%', height : '50px', display : "flex", flexDirection : 'row'}}>
                            <div>
                                <Filter 
                                    key = {'record'} 
                                    group_filter = {this.props.search_range_filter.record}
                                    update_filter = {(filter,key) => this.props.update_search_range_filter(filter,key)}
                                />
                            </div>
                            <Typography style = {{width : '10%', marginTop : '5px'}} variant = 'subtitle2' color = 'textPrimary'> of {this.props.search_range_filter.record.total_count}</Typography>
                        </div>}
                    <Fragment>
                        {this.getRecoLabel()}
                        <RecordList 
                            body_height = {this.getBodyHeight() - 100}
                            group_display_name = {this.props.group_display_name}
                            field_display_name = {this.props.field_display_name}
                            top_margin = "0px"
                            fields = {field_data}
                            field_in_focus = {null}
                            location = {'RecoSpace'}
                            field_type = {'field'}
                            focus_field = {(field_object) => this.focusField(field_object)}
                            accept_field_drops = {false}
                            columns = {columns}
                            move_field = {(field_data, field_type, drop_result) => this.props.move_field(field_data, field_type, drop_result)}
                            syncing_field = {this.props.syncing_field}
                            unsynced_fields = {this.props.unsynced_fields}
                            create_new_group_from_field = {(field_data) => this.props.create_new_group_from_field (field_data)}
                            show_group_name = {true}
                            highlight_name = {true}
                            pagination = {false}
                            group_filter = {this.props.similar_to_group_filter}
                            update_filter = {(filter) => this.props.update_filter(filter)}
                            focus_record = {(record)=> this.setState({...this.state,record_in_focus : record})}
                            record_in_focus = {this.state.record_in_focus}
                            report_info = {this.props.report_info}
                        />
                    </Fragment>
                </div>
                )
            }
        }
    }

    renderSimilarSingletonTable = (entity_key, value_key, columns, filter_similarity) => {
        if (this.props[entity_key] !== null) {
            let singleton_data = this.props[entity_key][value_key]
            console.log("singleton Table",this.props[entity_key][value_key])

            if (singleton_data.length === 0) {
                return (
                    <div>
                        {entity_key === 'search_results' && <div style = {{width : '100%', height : '50px', display : "flex", flexDirection : 'row'}}>
                            <div>
                                <Filter 
                                    key = {'singleton'} 
                                    group_filter = {this.props.search_range_filter.singleton}
                                    update_filter = {(filter,key) => this.props.update_search_range_filter(filter,key)}
                                />
                            </div>
                            <Typography style = {{width : '10%', marginTop : '5px'}} variant = 'subtitle2' color = 'textPrimary'> of {this.props.search_range_filter.singleton.total_count}</Typography>
                        </div>}
                        <div
                            style = {{
                                width : '100%',
                                height : (this.getBodyHeight() - 100) + "px",
                                display : 'flex',
                                flexDirection : 'row',
                                justifyContent : 'center',
                                alignItems : 'center'
                            }}
                        >
                            <Typography variant = 'caption' color = 'textSecondary'>No similar singletons available</Typography>
                        </div>
                    </div>
                    
                )
            } else if (this.state.singleton_in_focus !== null) {
                return (
                    <Record 
                        record={this.state.singleton_in_focus} 
                        unfocus_record = {() => this.setState({...this.state, singleton_in_focus : null})}
                        unfocus_field = {()=>this.props.unfocus_field}
                    ></Record>
                )
            } else {
                // let filter = this.props.search_range_filter.singleton
                // let range = filter.range
                // let new_range = { 
                //     lower : range[0],
                //     upper : range[1]
                // }
                // filter.range = new_range
                columns = ["$icon","$options", "$golden"]
                Object.keys(singleton_data[0].wv_field_list).map((field) => columns.push(field))
                columns.push("Score")
                return (
                    <div>
                        {entity_key === 'search_results' && <div style = {{width : '100%', height : '50px', display : "flex", flexDirection : 'row'}}>
                            <div>
                                <Filter 
                                    key = {'singleton'} 
                                    group_filter = {this.props.search_range_filter.singleton}
                                    update_filter = {(filter,key) => this.props.update_search_range_filter(filter,key)}
                                />
                            </div>
                            <Typography style = {{width : '10%', marginTop : '5px'}} variant = 'subtitle2' color = 'textPrimary'> of {this.props.search_range_filter.singleton.total_count}</Typography>
                        </div>}
                        <Fragment>
                        {this.getRecoLabel()}
                        <RecordList 
                            body_height = {this.getBodyHeight() - 100}
                            group_display_name = {this.props.group_display_name}
                            field_display_name = {this.props.field_display_name}
                            top_margin = "0px"
                            fields = {singleton_data}
                            field_in_focus = {null}
                            location = {"RecoSpace"}
                            field_type = {'singleton'}
                            focus_field = {(field_object, field_type) => this.focusField(field_object, field_type)}
                            accept_field_drops = {false}
                            columns = {columns}
                            move_field = {(field_data, field_type, drop_result) => this.props.move_field(field_data, field_type, drop_result)}
                            syncing_field = {this.props.syncing_field}
                            unsynced_fields = {this.props.unsynced_fields}
                            create_new_group_from_field = {(field_data) => this.props.create_new_group_from_field (field_data)}
                            make_singleton = {(field_data) => this.props.make_singleton(field_data)}
                            highlight_name = {true}
                            pagination = {false}
                            group_filter = {this.props.similar_to_group_filter}
                            update_filter = {(filter) => this.props.update_filter(filter)}
                            focus_record = {(record)=> this.setState({...this.state, singleton_in_focus : record})}
                            record_in_focus = {this.state.singleton_in_focus}
                            report_info = {this.props.report_info}
                        />
                    </Fragment>
                    </div>
                )
            }
        }
    }

    renderSimilarGlobalFields = (entity_key, value_key, filter_similarity) => {
        if (this.props[entity_key] !== null) {
            let global_fields_data
            if (filter_similarity) {
                global_fields_data = this.props[entity_key][value_key][this.state.similarity_type]
            } else {
                global_fields_data = this.props[entity_key][value_key]
            }
            

            if (global_fields_data.length === 0) {
                return (
                    <div
                        style = {{
                            width : '100%',
                            height : (this.getBodyHeight() - 100) + "px",
                            display : 'flex',
                            flexDirection : 'row',
                            justifyContent : 'center',
                            alignItems : 'center'
                        }}
                    >
                        <Typography variant = 'caption' color = 'textSecondary'>No similar Global Fields available</Typography>
                    </div>
                )
            } else {
                var toPX = require('to-px')
                return (
                    <Fragment>
                        <div style = {{width : '100%', height : this.getBodyHeight(), padding : '10px'}}>
                        {this.getRecoLabel()}
                            <GlobalFieldList
                                ic_name = {this.props.ic_name} 
                                version = {this.props.version}
                                step_tag = {this.props.step_tag} 
                                global_field_display_name = {this.props.global_field_display_name}
                                width = {toPX("25vw") - 10}
                                height = {this.getBodyHeight() - 150}
                                global_fields = {global_fields_data}
                                field_in_focus = {this.props.field_in_focus}
                                mapping_global_field = {this.props.mapping_global_field}
                                show_options
                                show_score
                                group_in_focus = {this.props.group_in_focus}
                                map_global_field = {(entity_id, global_field) => this.props.map_global_field(entity_id, global_field)}
                                cursor = {null}
                                select_global_field = {() => null}
                                refresh_report_and_data = {this.props.refresh_report_and_data}
                            />
                        </div>
                    </Fragment>
                )
            }
        }
    }

    renderGroupDetail = (from) => {
            return (
                <GroupDetail 
                    body_height = {this.getBodyHeight()} 
                    group_data = {this.props.similar_group_in_focus}
                    group_display_name = {this.props.group_display_name}
                    field_display_name = {this.props.field_display_name} 
                    global_fields = {this.props.global_fields}
                    global_fields_error = {this.props.global_fields_error}
                    mapping_global_field = {this.props.mapping_global_field}
                    map_global_field = {(entity_id, global_field) => this.props.map_global_field(entity_id, global_field)}
                    pinned_groups = {this.props.pinned_groups}
                    pin_group = {(group_id, action) => this.props.pin_group(group_id, action)}
                    allow_name_edit = {false}
                    from = {from}
                    location = {"RecoSpace"}
                    unfocus_group = {() => this.focusGroup(null)}
                    ic_name = {this.props.ic_name} 
                    version = {this.props.version}
                    step_tag = {this.props.step_tag} 
                    refresh_space = {() => this.props.get_groups()}
                    field_in_focus = {this.props.field_in_focus}
                    focus_field = {(field_object, field_type) => this.focusField(field_object, field_type)}
                    accept_field_drops = {true}
                    move_field = {(field_data, field_type, drop_result) => this.props.move_field(field_data, field_type, drop_result)}
                    syncing_field = {this.props.syncing_field}
                    unsynced_fields = {this.props.unsynced_fields}
                    create_new_group_from_field = {(field_data) => this.props.create_new_group_from_field(field_data)}
                    make_singleton = {(field_data) => this.props.make_singleton(field_data)}
                    checking_merge_groups = {this.props.checking_merge_groups}
                    group_filter = {this.props.similar_to_group_filter}
                    report_info = {this.props.report_info}
                    update_filter = {(filter) => this.props.update_filter(filter)}   
                    set_record_primary = {(field_data) => this.props.set_record_primary(field_data)}      
                />
            )
    }

    focusField = (field_object, field_type) => {
        // this.setState({...this.state, field_in_focus : field_object, field_type_in_focus : field_type}, () => {
        //     if (field_object !== null) {
        //         this.props.update_space_state(1, 'field_detail')
        //     } else {
        //         this.props.update_space_state(1, 'group_detail')
        //     }
        // })
        let space_state
        let show_field_detail
        if (field_object === null) {
            show_field_detail = false
            if (this.state.level_2_tab_index === 0) {
                space_state = 'group_detail'
            } else {
                space_state = null
            }
        } else {
            space_state = 'field_detail'
            show_field_detail = true
        }

        this.setState({...this.state, show_field_detail : show_field_detail}, () => {
            this.props.focus_similar_field(field_object, field_type, () => this.props.update_space_state(1, space_state))
        })
    }

    renderFieldDetail = (from) => {
        return (
            <div style = {{width : '100%', height : (this.getBodyHeight() + 50) + "px"}}>
                <FieldDetail
                    key = {'recospace-field-detail'}
                    body_height = {this.getBodyHeight() + 50}
                    group_display_name = {this.props.group_display_name}
                    field_display_name = {this.props.field_display_name}
                    global_field_display_name = {this.props.global_field_display_name}
                    ic_name = {this.props.ic_name} 
                    version = {this.props.version} 
                    report_info = {this.props.report_info}
                    global_fields = {this.props.global_fields}
                    global_fields_error = {this.props.global_fields_error}
                    mapping_global_field = {this.props.mapping_global_field}
                    map_global_field = {(entity_id, global_field) => this.props.map_global_field(entity_id, global_field)}
                    field_in_focus = {this.props.similar_field_in_focus}
                    field_type = {this.props.similar_field_in_focus_type}
                    from = {from}
                    unfocus_field = {(field_object) => this.focusField(null, null)}
                    column_index = {this.props.column_index}
                    checking_field_similarity = {this.props.checking_field_similarity}
                    field_similarity_col_indices = {this.props.field_similarity_col_indices}
                    allow_mapping_global_field = {false}
                />
            </div>
        )
    }

    getGroupFrom = () => {
        let from = ""
        if (this.state.level_1_tab_index === 0) {
            if (this.state.level_2_tab_index === 0) {
                from = from + "Similar " + this.props.group_display_name + "s to "  +this.props.group_display_name
            }
        }

        if (this.state.level_1_tab_index === 1) {
            
            if (this.state.level_2_tab_index === 0) {
                from = from + "Similar " + this.props.group_display_name + "s to " + this.props.field_display_name
            }
        }

        if (this.state.level_1_tab_index === 2) {
            
            if (this.state.level_2_tab_index === 0) {
                from = from + "Search Results/" + this.props.group_display_name + "s"
            }
        }

        return from
    }

    getFieldFrom = () => {
        let from = ""
        if (this.state.level_1_tab_index === 0) {
            if (this.state.level_2_tab_index === 0) {
                from = from + "Similar " + this.props.group_display_name + "s to "  + this.props.group_display_name + "/" + this.props.similar_group_in_focus.group_name
            }

            if (this.state.level_2_tab_index === 1) {
                from = from + "Similar " +  this.props.field_display_name + "s to " + this.props.group_display_name
            }

            if (this.state.level_2_tab_index === 2) {
                from = from + "Similar Singletons to " + this.props.group_display_name
            }
        }

        if (this.state.level_1_tab_index === 1) {
            
            if (this.state.level_2_tab_index === 0) {
                from = from + "Similar " + this.props.group_display_name + "s to " + this.props.field_display_name + "/" + this.props.similar_group_in_focus.group_name
            }

            if (this.state.level_2_tab_index === 1) {
                from = from + "Similar " + this.props.field_display_name+ "s to " + this.props.field_display_name
            }

            if (this.state.level_2_tab_index === 2) {
                from = from + "Similar Singletons to " + this.props.field_display_name
            }
        }

        if (this.state.level_1_tab_index === 2) {
            
            if (this.state.level_2_tab_index === 0) {
                from = from + "Search Results/" + this.props.group_display_name + "/" + this.props.similar_group_in_focus.group_name
            }

            if (this.state.level_2_tab_index === 1) {
                from = from + "Search Results/" + this.props.field_display_name + "/"
            }

            if (this.state.level_2_tab_index === 2) {
                from = from + "Search Results/Singletons"
            }
        }

        return from
    }

    render() { 
        console.log("IFC :: Groups Detail Similar", this.props.similar_group_in_focus)
        const { classes } = this.props
        return (
            <div style = {{width : '100%', height : '100%', overflow : 'hidden'}}>
                {/* {this.state.show_field_detail && this.props.similar_field_in_focus !== null && this.renderFieldDetail(this.getFieldFrom())} */}
                {this.renderLevel1()}
                {this.state.show_group_detail && this.props.similar_group_in_focus !== null && this.renderGroupDetail(this.getGroupFrom())}
                {(this.props.group_in_focus !== null || this.props.search_results !== null) && !this.state.show_group_detail && this.renderLevel2()}
                {(this.props.group_in_focus !== null || this.props.search_results !== null) && !this.state.show_group_detail && this.renderChildTabContent()}
                {/* {((this.props.group_in_focus !== null && this.state.group_in_focus === null) || (this.props.search_results !== null)) && this.renderChildTabContent()} */}
            </div>
        );
    }
}
 
export default withStyles(styles)(RecoSpace);